// data/languages/wolof/categories/couleurs.ts

import { CategoryData } from '../../../../types/types';

export const couleurs: CategoryData = {
  'Weex (Blanc)': { translation: 'Blanc', translationEn: 'White', illustration: '⚪', audio: 'Wf-weex' },
  'Ñuul (Noir)': { translation: 'Noir', translationEn: 'Black', illustration: '⚫' },
  'Xonq (Rouge)': { translation: 'Rouge', translationEn: 'Red', illustration: '🔴' },
  'Blu (Bleu)': { translation: 'Bleu', translationEn: 'Blue', illustration: '🔵' },
  'Wert (Vert)': { translation: 'Vert', translationEn: 'Green', illustration: '🟢' },
  'Melo (Jaune)': { translation: 'Jaune', translationEn: 'Yellow', illustration: '🟡', audio: 'Wf-melo' },
  'Gris (Gris)': { translation: 'Gris', translationEn: 'Gray', illustration: '⚪' },
  'Caf (Marron)': { translation: 'Marron', translationEn: 'Brown', illustration: '🟤' },
  'Oraans (Orange)': { translation: 'Orange', translationEn: 'Orange', illustration: '🟠' },
  'Wiolet (Violet)': { translation: 'Violet', translationEn: 'Purple', illustration: '🟣' },
  'Roos (Rose)': { translation: 'Rose', translationEn: 'Pink', illustration: '🌸' },
  'Xonq curr (Rouge foncé)': { translation: 'Rouge foncé', translationEn: 'Dark red', illustration: '🔴' },
  'Blu curr (Bleu foncé)': { translation: 'Bleu foncé', translationEn: 'Dark blue', illustration: '🔵' },
  'Wert curr (Vert foncé)': { translation: 'Vert foncé', translationEn: 'Dark green', illustration: '🟢' },
  'Melo curr (Jaune foncé)': { translation: 'Jaune foncé', translationEn: 'Dark yellow', illustration: '🟡' },
};

export default couleurs;

export {};